import { EntityRepository, Repository } from "typeorm";
import { SaleOrderItemsLog } from "../so-items-log.entity";

@EntityRepository(SaleOrderItemsLog)
export class SoItemsLogRepository extends Repository<SaleOrderItemsLog>{


}
